import "./services/appInsights";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { RegionProvider } from "./contexts/RegionContext";
import { VerticalsProvider } from "./contexts/VerticalsContext";
import { ApplicationTypeProvider } from "./contexts/ApplicationTypeContext";
import { ApplicationProvider } from "./contexts/ApplicationContext";
import { DealProvider } from "./contexts/DealContext";
import { OrganizationProvider } from "./contexts/OrganizationContext";
import { UserBaseProvider } from "./contexts/UserBaseContext";
import { DeploymentModelProvider } from "./contexts/DeploymentModelContext";
import { LicenseProvider } from "./contexts/LicenseContext";
import { FeatureFlagsProvider } from "./contexts/FeatureFlagsContext";
import ErrorBoundary from "./components/ErrorBoundary";

// Authentication is now handled server-side (BFF): the backend issues an HttpOnly session cookie
// and AuthContext bootstraps from /Auth/validate. No MSAL in the browser.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
    <ThemeProvider>
      <AuthProvider>
        <RegionProvider>
          <OrganizationProvider>
            <LicenseProvider>
              <FeatureFlagsProvider>
                <VerticalsProvider>
                  <ApplicationProvider>
                    <ApplicationTypeProvider>
                      <DealProvider>
                        <UserBaseProvider>
                          <DeploymentModelProvider>
                            <App />
                          </DeploymentModelProvider>
                        </UserBaseProvider>
                      </DealProvider>
                    </ApplicationTypeProvider>
                  </ApplicationProvider>
                </VerticalsProvider>
              </FeatureFlagsProvider>
            </LicenseProvider>
          </OrganizationProvider>
        </RegionProvider>
      </AuthProvider>
    </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
